import { createFileRoute } from '@tanstack/react-router';

import { PostSignInPasskeyScreen } from '@/auth/PostSignInPasskeyScreen';

/**
 * Thin route-file shell. The screen component lives at
 * `src/auth/post-sign-in-passkey-screen.tsx`.
 * See `apps/client/docs/design.md` §"Route files are thin shells".
 */

export const Route = createFileRoute('/post-sign-in-passkey')({
  component: PostSignInPasskeyScreen,
});
